export enum ViewMode {
  CREATE = 1,
  EDIT = 2,
}